import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Check for saved theme preference in localStorage
// Default to dark mode if no preference is saved
const savedTheme = localStorage.getItem('darkMode');
const isDarkMode = savedTheme !== null ? savedTheme === 'true' : true;

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#4361ee',
        secondary: '#3f37c9',
        accent: '#4895ef',
        background: '#f8f9fa',
        surface: '#ffffff',
        greyBackground: '#f3f4f6',
        greyIcon: '#9095A0',
        error: '#e63946',
        info: '#457b9d',
        success: '#2a9d8f',
        warning: '#f77f00',
        barBackground: '#f5f5f5',
        cardBackground: '#ffffff',
        textPrimary: '#212529',
        textSecondary: '#495057',
        font: {
          family: 'Inter, sans-serif',
        },
      },
      dark: {
        primary: '#4cc9f0',
        'primary-darken2': '#0a8bbd', // Added darker shade of primary for dark mode
        secondary: '#4361ee',
        accent: '#3a0ca3',
        background: '#121212',
        surface: '#1e1e1e',
        greyBackground: '#2d2d2d',
        greyIcon: '#9095A0',
        error: '#e63946',
        info: '#457b9d',
        success: '#2a9d8f',
        warning: '#f77f00',
        barBackground: '#2d2d2d',
        cardBackground: '#2d2d2d',
        textPrimary: '#f8f9fa',
        textSecondary: '#e9ecef',
        font: {
          family: 'Inter, sans-serif',
        },
      },
    },
    dark: isDarkMode, // Set dark mode based on localStorage
  },
});
